import { useCallback, useRef } from 'react'

// @see https://epicreact.dev/the-latest-ref-pattern-in-react/
const useGetLatest = (val: any, deps: Array<any> = []) => {
  const ref = useRef(val)
  ref.current = val
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(() => ref.current, deps)
}

export default useGetLatest
